import type { UseFormReturn } from "react-hook-form";
import { t } from "ttag";

import type { ContactInfoFormValues } from "@/features/onboarding/hooks";
import { Form, Heading, HomeIcon, Input, MapPointIcon } from "@/shared/ui";
import { AddressAutocompleteInput } from "./address-autocomplete-input";

interface AddressFieldsetProps {
  title?: string;
  type: "billing" | "shipping";
  form: UseFormReturn<ContactInfoFormValues>;
}

export const AddressFieldset = ({
  form,
  title,
  type,
}: AddressFieldsetProps) => {
  return (
    <fieldset className="col-span-full flex flex-col gap-4 text-neutral-900">
      {title && (
        <Heading level={3} size="x-small">
          {title}
        </Heading>
      )}

      <div className="grid items-end gap-x-8 gap-y-12 pb-5 sm:grid-cols-3">
        <AddressAutocompleteInput form={form} type={type} />

        <Form.Field
          control={form.control}
          name={`${type}.apartmentNumber`}
          render={() => (
            <Form.Item
              id={`${type}-apartment-number`}
              className="mf-masked mf-listen relative"
            >
              <Form.Label>{t`Apartment number`}</Form.Label>
              <Form.Control>
                <Input.Root
                  {...form.register(`${type}.apartmentNumber`)}
                  placeholder={t`1A`}
                >
                  <Input.Slot>
                    <HomeIcon />
                  </Input.Slot>
                </Input.Root>
              </Form.Control>
              <Form.Message
                compact={false}
                className="absolute inset-x-0 top-full mt-1"
              />
            </Form.Item>
          )}
        />

        <Form.Field
          control={form.control}
          name={`${type}.city`}
          render={() => (
            <Form.Item
              id={`${type}-city`}
              className="mf-masked mf-listen relative sm:col-span-2"
            >
              <Form.Label aria-required>{t`City`}</Form.Label>
              <Form.Control>
                <Input.Root
                  {...form.register(`${type}.city`)}
                  placeholder={t`Phoenix`}
                >
                  <Input.Slot>
                    <MapPointIcon />
                  </Input.Slot>
                </Input.Root>
              </Form.Control>
              <Form.Message
                compact={false}
                className="absolute inset-x-0 top-full mt-1"
              />
            </Form.Item>
          )}
        />

        <Form.Field
          control={form.control}
          name={`${type}.zipCode`}
          render={() => (
            <Form.Item
              id={`${type}-zip-code`}
              className="mf-masked mf-listen relative"
            >
              <Form.Label aria-required>{t`Zip code`}</Form.Label>
              <Form.Control>
                <Input.Root
                  {...form.register(`${type}.zipCode`)}
                  placeholder="12345"
                >
                  <Input.Slot>
                    <HomeIcon />
                  </Input.Slot>
                </Input.Root>
              </Form.Control>
              <Form.Message
                compact={false}
                className="absolute inset-x-0 top-full mt-1"
              />
            </Form.Item>
          )}
        />
      </div>
    </fieldset>
  );
};
